<template>
    <span class="glyphicon" :class="'glyphicon-'+type"></span>
</template>
<script>
export default {
        props: ['type'],
        data(){
          return {}
        }
    }
</script>